import { DckActionTypes } from "dck-redux"
import * as types from "./types"
import * as ItemTypes from "../items/types"

export function changeLoanStatus(loanId, newStatus) {
  return {
    type: types.CHANGE_LOAN_STATUS,
    loanId,
    newStatus
  }
}

export function resubmitLoan(loanId, newStatus) {
  return {
    type: types.RESUBMIT_LOAN_ACTION,
    loanId,
    newStatus
  }
}

export function resetLoanData() {
  return {
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Loan,
    data: []
  }
}

export function assignToNewUser(loanId, username) {
  return {
    type: types.ASSIGN_LOAN_TO_USER_ACTION,
    loanId,
    username
  }
}

export function loadLoanDetails(loanId) {
  return {
    type: types.LOAD_LOAN_DETAILS_ACTION,
    loanId
  }
}

export function getCustomerLoans(customerId) {
  return {
    type: types.GET_CUSTOMER_LOANS_ACTION,
    customerId
  }
}

export function resetCustomerLoans() {
  return {
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.CustomerLoans,
    data: []
  }
}

export function getBusinessLoans(businessId) {
  return {
    type: types.GET_BUSINESS_LOANS_ACTION,
    businessId
  }
}

export function resetBusinessLoans() {
  return {
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.BusinessLoans,
    data: []
  }
}

export function updateLoanGroupAction(loanId, group) {
  return {
    type: types.UPDATE_LOAN_GROUP_ACTION,
    loanId,
    group
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/loans.js